import { Box, Paper, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import { useNavigate, useParams } from "react-router-dom";
import { Documento, ISdocumento } from "../../../types/processo/Documento";
import { useEffect, useState } from "react";
import { useGetDocumentoQuery } from "../createDocumento/documentoApiSlice";
import configUrls from "../../../config/configUrls";
import { useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import CabecalhoDocumentos from "../documentoView/CabecalhoDocumentos";
import { DocumentoEditarForm } from "./DocumentoEditarForm";
import { useUpdateDocumentoEditarConteudoMutation } from "./documentoEditarApiSlice";
import errorFormat from "../../../utils/errorFormat";
import { skipToken } from "@reduxjs/toolkit/query";

export const DocumentoEditar = () => {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const [documento, setDocumento] = useState<Documento>(ISdocumento);
  const { id } = useParams();

  const { processoSelecionado } = useSelector(
    (state: RootState) => state.processoSelecionado
  );
  useEffect(() => {
    if (!processoSelecionado) {
      alert("Nenhum processo selecionado");
      window.location.href = configUrls.PROCESSO_LIST_RT;
    }
  }, [processoSelecionado]);

  const [updateDocumento, status] = useUpdateDocumentoEditarConteudoMutation();

  const { data, isFetching, error } = useGetDocumentoQuery(id || skipToken, {
    refetchOnMountOrArgChange: true,
  });
  useEffect(() => {
    if (data) {
      setDocumento(data);
    } else if (error) {
      enqueueSnackbar("Registro não encontrado!", { variant: "error" });
      //window.location.href = configUrls.PROCESSO_LIST_RT;
    } else if (isFetching) {
      enqueueSnackbar("Buscando registro...", { variant: "info" });
    } else {
      enqueueSnackbar("Registro não encontrado!", { variant: "error" });
      //window.location.href = configUrls.PROCESSO_LIST_RT;
    }
  }, [data, error, isFetching, enqueueSnackbar]);

  const handleCorpoChangeQuill = (value: string) => {
    setDocumento((prev) => ({
      ...prev,
      conteudo: value,
    }));
  };

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    await updateDocumento(documento);
  }

  useEffect(() => {
    if (status.isError) {
      enqueueSnackbar("Registro não alterado!", { variant: "error" });
      const erroReturn: string = errorFormat(status);
      enqueueSnackbar(erroReturn, { variant: "error" });
    }

    if (status.isSuccess) {
      enqueueSnackbar("Registro alterado com sucesso!", {
        variant: "success",
      });
      {
        /*navigate(-1);*/
      }
    }
  }, [status]);
 
  return (
    <Box sx={{ padding: 1 }}>
      <Paper
        elevation={3}
        sx={{
          padding: 2,
          backgroundColor: "#f5f5f5", // Cor de fundo cinza claro
          borderRadius: 2, // Bordas arredondadas
          boxShadow: 3, // Sombra para destacar o papel
          overflow: "hidden", // Evita que o conteúdo transborde
          wordWrap: "break-word", // Quebra palavras longas para evitar transbordamento
          display: "flex",
          flexDirection: "column", // Empilha o cabeçalho e o conteúdo
          alignItems: "flex-start", // Alinha ao início (esquerda)
          width: "100%",
          maxWidth: "100%",
        }}
      >
        <Box
          id="cabecalho"
          sx={{
            display: "flex",
            width: "100%",
          }}
        >
          <CabecalhoDocumentos documento={documento} />
        </Box>
       
       
        <Box id="conteudo" mt={2}>
          <DocumentoEditarForm
            documento={documento}
            handleCorpoChangeQuill={handleCorpoChangeQuill}
            handleSubmit={handleSubmit}
          />
        </Box>

       
      </Paper>
    </Box>
  );
};
